// Removed — onboarding void endpoints no longer exist
export function* watchVoid() {}
